<script lang="ts" setup>
import { defineProps } from "vue";
import templateOne from "./template1.vue";

interface Props {
    modals: any[];
}

const props = defineProps<Props>();
</script>

<template>
    <div class="wrapper">
        <template v-for="(modal, index) in modals" :key="index">
            <template-one v-if="modal.acf.type === 'template_1'" :key="index" :modal-id="modal.acf.popup_id" :show-on-page-load="modal.acf.show_on_page_load" :data="modal.acf.data" />
        </template>
    </div>
</template>
